import 'babel-polyfill'
import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Route, BrowserRouter } from 'react-router-dom'

import './scss/App.scss'
import { axiosConfig } from './js/util/initial-setup.js'
import RouterWrapper from './js/routerWrapper'

import { createAppStore } from './js/store'
const store = createAppStore()

axiosConfig(store)

render(
  <Provider store={store}>
    <BrowserRouter>
      <Route component={RouterWrapper} />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
)
